import { render, staticRenderFns } from "./SpeakersSelectComponent.vue?vue&type=template&id=561f26d8"
import script from "./SpeakersSelectComponent.vue?vue&type=script&lang=js"
export * from "./SpeakersSelectComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports